module.exports = __webpack_public_path__ + "res/img_ph_1.45f42f53120a8a70d4d21f92c1c4a074.png";